import React from "react";
import { TextField } from "@mui/material";
import ConfirmModal from "../confirm.modal";
import type { ModalComponentProps } from "../../../types/modal.types";

interface EventCreateModalProps extends ModalComponentProps {
  changed?: (value: string) => void;
}

export default function EventCreateModal(props: EventCreateModalProps) {
  const { id, onClose, changed } = props;

  const [value, setValue] = React.useState("");

  return (
    <ConfirmModal
      title="이벤트 - 항목 추가"
      id={id}
      onClose={onClose}
      content=""
      rightButton={{
        onClick: () => {
          changed?.(value);
          onClose?.();
        },
        disabled: !value,
        title: "추가",
      }}
    >
      <p className="text-black/60 text-[16px] pb-6">
        지점의 기타 이벤트 관련 내용을 입력해주세요.
        <br />
        (ex. 갤럭시 워치 증정 등)
      </p>
      <TextField
        label="이벤트 내용*"
        className="w-[552px] mt-[28px]"
        maxRows={9}
        slotProps={{
          inputLabel: { shrink: true },
          input: {
            sx: {
              height: 200,
              alignItems: "flex-start",
            },
          },
        }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </ConfirmModal>
  );
};
